<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div class="pa-2" v-if="!loading&&player">
            <v-layout row wrap>
                <v-flex xs2 class="pt-3"><strong>{{times[frameIndex]}}</strong></v-flex>
                <v-flex xs9>
                    <v-slider
                            v-model="frameIndex"
                            :max="frames.length-1"
                            @change="refreshData"
                            :min="0"
                    ></v-slider>
                </v-flex>
                <v-flex xs-1 class="pa-3">
                    <v-icon v-if="!interval" class="cursor-as-pointer" @click="play()">fa-play</v-icon>
                    <v-icon v-if="interval" class="cursor-as-pointer" @click="pause()">fa-pause</v-icon>
                </v-flex>
            </v-layout>
        </div>
        <heatmapjs-vue v-if="!loading&&heatmapData" v-bind:style="{ height: height + 'px', width: width + 'px', backgroundImage:imageUrl ? 'url('+imageUrl+')': 'none'}"
                       class="heatmapjs-container" :options="options"
                       :max="max"
                       :min="min" :data="heatmapData"></heatmapjs-vue>
    </div>
</template>

<script>
    import {callAPI} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    export default {
        props: {
            dateRange: {type: Object, default: null},
            height: {type: Number, default: 500},
            width: {type: Number, default: 500},
            min: {type: Number, default: 0},
            max: {type: Number, default: 100},
            imageUrl:{type: String, default: null},
            points:{type: Array, default: ()=>{return[]}},
            agg:{type: String, default:"D"},
            aggOpp:{type: String, default:"mean"},
            onOnly:{type: Boolean, default:false},
            player:{type: Boolean, default:false},
            options: {
                type: Object, default: () => {
                    return {
                        radius: 150,
                        blur: 1,
                        maxOpacity: 0.8,
                    }
                }
            },
        },
        components: {LoadingProgressBar},
        computed: {},
        name: 'HeatmapWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                heatmapData:null,
                timeout:null,
                frames:[],
                frameIndex:0,
                interval:null,
                times:[]
            }
        },
        mounted(){
            this.refresh()
        },
        beforeDestroy: function(){
            clearInterval(this.interval)
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            refreshData() {
                this.heatmapData=this.frames[this.frameIndex]
            },
            incPlay(){
                if(this.frameIndex<this.frames.length-1){
                    this.frameIndex+=1;
                    this.refreshData()
                } else {
                    clearInterval(this.interval)
                    this.interval=null
                }
            },
            play(){
                let me=this
                me.interval=setInterval(function() { me.incPlay() }, 300);
            },
            pause(){
                clearInterval(this.interval)
                this.interval=null
            },
            getData(){
                let me=this
                me.loading=true
                let pipeline=me.onOnly ? [{"type": "filter","filter_op": "eq", "filter_by": "* - on","filter_value": 1,},{type: "agg", agg: me.agg, agg_op: me.aggOpp}] : [{type: "agg", agg: me.agg, agg_op: me.aggOpp}]
                let promises=me.points.map((point)=>{return callAPI('data3/',{
                    date_range:[this.dateRange.start,this.dateRange.end],
                    filters: {
                        equipment_name: point.equipment_name,
                        sensor_name: point.name,
                        facility_name:point.facility_name ? point.facility_name : me.$store.state.pointsListStore.pointsList.facility_name
                    },
                    pipeline:pipeline
                })})
                Promise.all(promises).then(function(results) {
                    if(me.player){
                        me.times=results[0].data["timestamp"]
                        clearInterval(me.interval)
                        me.interval=null
                        let frames=[]
                        for (let findex in me.times){
                            frames.push(me.points.map((point,index)=>{
                                return {
                                    x:point.x,
                                    y:point.y,
                                    value:results[index].data[point.equipment_name+" - "+point.name] ? results[index].data[point.equipment_name+" - "+point.name][findex] : null
                                }
                            }))
                        }
                        me.frames=frames
                        me.frameIndex=0
                        me.refreshData()
                    } else {
                        me.heatmapData=me.points.map((point,index)=>{
                            return {
                                x:point.x,
                                y:point.y,
                                value:results[index].data[point.equipment_name+" - "+point.name] ? results[index].data[point.equipment_name+" - "+point.name].reduce((acc, curr) => curr ? curr : acc) : null
                            }
                        })
                    }

                    me.loading=false
                })
            }
        },

    }

</script>

<style scoped>

</style>
